'use strict';
var base = require('app_custom_mufe_revamp/product/base');

module.exports = function () {
    if (window.productDetailInitialized) {
        return;
    }
    window.productDetailInitialized = true;
    base.selectAttribute();
    base.colorAttribute();
    base.selectSize();
    base.removeBonusProduct();
    base.selectBonusProduct();
    base.enableBonusProductSelection();
    base.showMoreBonusProducts();
    base.addBonusProductsToCart();
    base.availability();
    base.addToCart();
    require('app_custom_mufe_revamp/product/needAnswer');
}
